module.exports = __webpack_public_path__ + "02cebc682b7e8c1aae26f63b9a8b90f3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/playStore.svg
// module id = 1383
// module chunks = 16